<template>
  <nav-bar title="管理首页">
    <template #right>
      <van-icon name="home-o" size="24" @click="handleHomeClick" />
    </template>
  </nav-bar>
  <Content :bottom="0">
    <Map />
    <div class="line-container" ref="line"></div>
    <van-cell-group class="group">
      <van-cell title="创建下级监管用户" to="/regulatoryUsers" is-link />
      <van-cell title="创建监管领导用户" to="/regulatoryLeaderUsers" is-link />
      <van-cell title="创建公司" to="/createCompany" is-link />
      <van-cell title="公司列表" to="/companyList" is-link />
      <van-cell title="调整非法经营企业 " to="/adjustAEnterprise" is-link />
      <!-- van-cell title="人员列表" to="/personnelList" is-link / -->
      <van-cell title="举报信息" to="/reportInformation" is-link />
      <van-cell title="车辆轨迹" @click="showView" is-link />
    </van-cell-group>
  </Content>
  <Trajectory ref="trajectory" :pointList="pointList" />
</template>
<script>
import { useRouter } from 'vue-router'
import { ref, onMounted } from 'vue'
import Trajectory from './trajectory.vue'
import * as echarts from 'echarts'
import { getStreetStatInfo } from '@/api/supervise'
import { useGetData } from '@/hooks/useGetData'
export default {
  name: 'ManagementHome',
  components: { Trajectory },
  setup() {
    localStorage.setItem('roleInfo', '{}')
    const regionCode = localStorage.getItem('tenant_region') || ''
    const router = useRouter()
    const handleHomeClick = () => {
      router.push('/welcome')
    }
    const trajectory = ref(null)
    const pointList = [
      {
        text: '2021-11-10 13:22:13',
        longitude: 123.446949,
        latitude: 41.723139
      },
      {
        text: '2021-11-10 15:36:24',
        longitude: 123.459995,
        latitude: 41.735693
      },
      {
        text: '2021-11-13 09:12:06',
        longitude: 123.485229,
        latitude: 41.673536
      },
      {
        text: '2021-11-16 11:36:22',
        longitude: 123.402969,
        latitude: 41.723908
      }
    ]
    const showView = () => {
      trajectory.value.showPopup()
    }
    const line = ref(null)
    onMounted(() => {
      const chart = echarts.init(line.value)
      // 折线图数据
      const xAxis = ref([])
      const yUser = ref([])
      const yIllUser = ref([])
      const yUserUse = ref([])
      const yIllUserUse = ref([])
      useGetData(getStreetStatInfo, data => {
        data.forEach(item => {
          xAxis.value.push(item.statDt)
          yUser.value.push(item.userCount)
          yIllUser.value.push(item.illeUserCount)
          yUserUse.value.push(item.userUseage)
          yIllUserUse.value.push(item.illeUserUseage)
        })
        chart.setOption({
          title: {
            text: '7日用户用量趋势表'
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '10%',
            right: '10%',
            bottom: '10%'
          },
          xAxis: {
            type: 'category',
            data: xAxis.value
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '违法用户数',
              type: 'line',
              data: yIllUser.value
            },
            {
              name: '合法用户数',
              type: 'line',
              data: yUser.value
            },
            {
              name: '日违法用量',
              type: 'line',
              data: yIllUserUse.value
            },
            {
              name: '日合法用量',
              type: 'line',
              data: yUserUse.value
            }
          ]
        })
      })(regionCode || '371500000000')
    })
    return { handleHomeClick, showView, trajectory, pointList, line, regionCode }
  }
}
</script>

<style lang="scss" scoped>
.group {
  margin-top: 16px;
}
.line-container {
  padding-top: 10px;
  background-color: #fff;
  margin-top: 16px;
  height: 230px;
}
</style>
